import { render, staticRenderFns } from "./que-es-un-molde-de-inyeccion.vue?vue&type=template&id=53242b0e&lang=html"
import script from "./que-es-un-molde-de-inyeccion.vue?vue&type=script&lang=js"
export * from "./que-es-un-molde-de-inyeccion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports